// extracted by mini-css-extract-plugin
module.exports = {"container":"ExecutiveSummaryHeader_container__2Q-aY","title":"ExecutiveSummaryHeader_title__3D7lh","dateRange":"ExecutiveSummaryHeader_dateRange__32T34"};